import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {frnt} from '@frnt/base/themes'
import {TopAppBarActionItem as RmwcTopAppBarActionItem} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const StyledRmwcTopAppBarActionItem = styled(RmwcTopAppBarActionItem)`
  @media ${frnt.devicePhone} {
    margin: 0;
  }

  ${(props) =>
    props.icon &&
    typeof props.icon === 'object' &&
    props.icon.strategy === 'component' &&
    `
    &&& {
      width: initial;
      font-size: 1rem;
      font-family: Roboto, sans-serif;
    }
  `}
`

const TopAppBarActionItem = ({children, ...otherProps}) => <StyledRmwcTopAppBarActionItem {...otherProps}>{children}</StyledRmwcTopAppBarActionItem>

TopAppBarActionItem.propTypes = {
  children: PropTypes.any
}

export {TopAppBarActionItem}
